/** Cores de eixo/legenda compatíveis com tema claro/escuro Thalamus. */
export function getChartTheme() {
  const dark = document.documentElement.classList.contains('dark');
  return {
    corFonte: dark ? 'rgba(255, 255, 255, .85)' : 'rgba(0, 0, 0, .85)',
    corFonteFraca: dark ? 'rgba(255, 255, 255, .15)' : 'rgba(0, 0, 0, .15)',
  };
}

export function baseChartOptions({
  corFonte,
  corFonteFraca,
  onClick,
  ySuggestedMax,
  suffix = '',
}) {
  return {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: 'index',
    },
    scales: {
      x: {
        ticks: { color: corFonte },
      },
      y: {
        suggestedMax: ySuggestedMax,
        ticks: { color: corFonte },
        grid: { color: corFonteFraca },
      },
    },
    plugins: {
      legend: {
        display: true,
        labels: {
          boxWidth: 12,
          boxHeight: 12,
          color: corFonte,
          font: { size: 13 },
        },
      },
      tooltip: {
        callbacks: {
          label(ctx) {
            const value = ctx.parsed?.y ?? ctx.raw?.y ?? ctx.raw;
            return `${ctx.dataset.label}: ${value}${suffix}`;
          },
        },
      },
    },
    onClick,
  };
}
